import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderComponent } from './components/header';
import { HeroSectionComponent } from './components/hero-section';
import { EmentaSectionComponent } from './components/ementa-section';
import { AulasSectionComponent } from './components/aulas-section';
import { Aula1SectionComponent } from './components/aula1-section';
import { Aula2SectionComponent } from './components/aula2-section';
import { Aula3SectionComponent } from './components/aula3-section';
import { Aula4SectionComponent } from './components/aula4-section';
import { Aula5SectionComponent } from './components/aula5-section';
import { Sprint1SectionComponent } from './components/sprint1-section';
import { Sprint2SectionComponent } from './components/sprint2-section';
import { Sprint3SectionComponent } from './components/sprint3-section';
import { Sprint4SectionComponent } from './components/sprint4-section';
import { FooterComponent } from './components/footer';

@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    HeaderComponent,
    HeroSectionComponent,
    EmentaSectionComponent,
    AulasSectionComponent,
    Aula1SectionComponent,
    Aula2SectionComponent,
    Aula3SectionComponent,
    Aula4SectionComponent,
    Aula5SectionComponent,
    Sprint1SectionComponent,
    Sprint2SectionComponent,
    Sprint3SectionComponent,
    Sprint4SectionComponent,
    FooterComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  currentTab = signal<string>('hero');

  onSelectTab(tabId: string) {
    this.currentTab.set(tabId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
